import React from 'react';
import { HeroPage } from '../../components/sections/home/HeroPage';
import Services from '../../components/sections/home/Services';
import Partners from '../../components/sections/home/Partners';
import HomeBanner from "../../components/sections/home/Banner";
import HomeGetInTouch from "../../components/sections/home/GetInTouch";
import HowSimfinance from "../../components/sections/home/HowSimfinance";
import WhySimfinance from "../../components/sections/home/WhySimfinance";
import useDataFormModal from '../../hooks/useDataFormModal';
import DataFormModal from '../../components/common/DataFormModal';

const Home = () => {
    // Inside your component:
    const { isModalOpen, closeModal } = useDataFormModal();


    return (
        <>
            <HeroPage />
            <HowSimfinance />
            <Partners />
            <Services />
            <WhySimfinance />
            <HomeBanner />
            <HomeGetInTouch />
            
            {/* Data Form Modal */}
            <DataFormModal isOpen={isModalOpen} onClose={closeModal} />
        </>
    );
};

export default Home;
